module.exports = "<p>\r\n  detail works!\r\n</p>\r\n"